import { render } from "./Categorie.vue?vue&type=template&id=fee8f0e6"
import script from "./Categorie.vue?vue&type=script&lang=js"
export * from "./Categorie.vue?vue&type=script&lang=js"

import "./Categorie.vue?vue&type=style&index=0&id=fee8f0e6&lang=css"

import exportComponent from "/Users/matjeez/Matjez/Projects/websites/simonkr-feb24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__